/**
 * @module FE-CU52_新規メインユーザー登録画面_仮登録
 */
import Header from '../../../components/header/Header.vue';
import BreadCrumbList from '../../../components/breadCrumb/List.vue';
import PcPageTitle from '../../../components/pcPageTitle/PcPageTitle.vue';
import NativeApi from '../../../api/nativeApi';
import PCFooter from '@/components/footer/PCFooter.vue';
import { checkMailAddressFormat } from '../../../utile/validation';

const PAGE_ID = 'FE-CU52';

export default {
  name: 'MainUserTempRegistration',
  components: {
    Header,
    BreadCrumbList,
    PcPageTitle,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t(
        '$vuetify.FECU52新規メインユーザー登録画面仮登録.新規メインユーザー登録仮登録'
      ),
      hintText: vm.$vuetify.lang.t(
        '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.C0001'
      ),
      // サービス
      service: {},
      services: [
        {
          id: 1,
          text: vm.$vuetify.lang.t(
            '$vuetify.FECU52新規メインユーザー登録画面仮登録.ホームセキュリティ'
          ),
        },
        {
          id: 2,
          text: vm.$vuetify.lang.t('$vuetify.FECU52新規メインユーザー登録画面仮登録.カメラ'),
        },
      ],
      // デバイスID
      deviceID: '',
      deviceIDError: '',
      // お客様番号
      customerNumber1: '',
      customerNumber2: '',
      customerNumberError1: '',
      customerNumberError2: '',
      // 認証番号
      certificationNumber1: '',
      certificationNumber2: '',
      certificationNumberError1: '',
      certificationNumberError2: '',
      // メールアドレス
      mail: '',
      mailError: '',
      // 確認用メールアドレス
      mailCheck: '',
      mailCheckError: '',

      dialog: false,
      saveDisableFlag: true,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t(
          '$vuetify.FECU52新規メインユーザー登録画面仮登録.新規メインユーザー登録仮登録'
        ),
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.C0001'
        ),
        services: [
          {
            id: 1,
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU52新規メインユーザー登録画面仮登録.ホームセキュリティ'
            ),
          },
          {
            id: 2,
            text: vm.$vuetify.lang.t('$vuetify.FECU52新規メインユーザー登録画面仮登録.カメラ'),
          },
        ],
      };
    },

    /**
     * デバイスID バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    deviceIDRule() {
      return [
        !!this.deviceID ||
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0012'
          ),
        /^[0-9a-zA-Z]+$/.test(this.deviceID) ||
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0014'
          ),
      ];
    },

    /**
     * お客様番号(ホームセキュリティ) バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    customerNumberRule1() {
      return [
        !!this.customerNumber1 ||
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0001'
          ),
        /^[0-9]*$/.test(this.customerNumber1) ||
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0003'
          ),
      ];
    },

    /**
     * お客様番号(カメラ) バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    customerNumberRule2() {
      return [
        /^[0-9]*$/.test(this.customerNumber2) ||
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0003'
          ),
      ];
    },

    /**
     * 認証番号(ホームセキュリティ) バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    certificationNumberRule1() {
      return [
        !!this.certificationNumber1 ||
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0007'
          ),
        /^[0-9]*$/.test(this.certificationNumber1) ||
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0018'
          ),
      ];
    },

    /**
     * 認証番号(カメラ) バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    certificationNumberRule2() {
      return [
        /^[0-9]*$/.test(this.certificationNumber2) ||
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0018'
          ),
      ];
    },

    /**
     * メールアドレス バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    mailRule() {
      return [
        !!this.mail ||
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0008'
          ),
        typeof this.mail === 'undefined'
          ? true
          : checkMailAddressFormat(this.mail) ||
            this.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0019'
            ),
      ];
    },

    /**
     * 確認用メールアドレス バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    mailCheckRule() {
      return [
        !!this.mailCheck ||
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0009'
          ),
        !(this.mailCheck !== this.mail) ||
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0010'
          ),
        typeof this.mailCheck === 'undefined'
          ? true
          : checkMailAddressFormat(this.mailCheck) ||
            this.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0020'
            ),
      ];
    },

    /**
     * ユーザーID（メールアドレス）と確認用ユーザーID（メールアドレス）一致チェック
     * @returns {string} 不一致：メッセージ 一致：true
     */
    matchingMailCheckRule() {
      if (this.mail !== this.mailCheck) {
        return this.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0010'
        );
      } else {
        return true;
      }
    },

    customerNumber: {
      get() {
        if (this.service.id == 1) {
          return this.customerNumber1;
        } else if (this.service.id == 2) {
          return this.customerNumber2;
        }
      },
      set(value) {
        if (this.service.id == 1) {
          this.customerNumber1 = value;
        } else if (this.service.id == 2) {
          this.customerNumber2 = value;
        }
      },
    },

    certificationNumber: {
      get() {
        if (this.service.id == 1) {
          return this.certificationNumber1;
        } else if (this.service.id == 2) {
          return this.certificationNumber2;
        }
      },
      set(value) {
        if (this.service.id == 1) {
          this.certificationNumber1 = value;
        } else if (this.service.id == 2) {
          this.certificationNumber2 = value;
        }
      },
    },
  },
  created() {
    this.service = { id: 1, text: 'ホームセキュリティ' };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$store.state.serviceCheck && vm.$store.state.privacyPolicyCheck) {
        next();
      } else {
        vm.$router.replace({ path: '/Sorry' });
      }
    });
  },
  /** @type {Methods} */
  methods: {
    /**
     * エラーダイアログ
     */
    async callSaveMessageDialog(message) {
      await this.$errorDialog(message);
    },
    /**
     * 仮登録ボタン押下時のアクション
     */
    async callSaveAgreementDialogDialog() {
      if (this.service.id == 1 || (!this.customerNumber && !this.certificationNumber)) {
        const result = await this.$agreementDialog(
          '$vuetify.agreementDialog.確認',
          '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.C0002',
          '$vuetify.agreementDialog.いいえボタン',
          '$vuetify.agreementDialog.はいボタン'
        );
        if (result === true) {
          // 追加したいサービスにより分岐
          if (this.service.id == 1) {
            // ホームセキュリティ
            await this.APP_CU5201();
          } else {
            // カメラ
            await this.APP_CU5202();
          }
        } else {
          // キャンセル
        }
      } else {
        // お客様番号/認証番号が入力されている場合
        this.callSaveAgreementSelectDialog();
      }
    },
    /**
     * 地区選択ダイアログ
     */
    async callSaveAgreementSelectDialog() {
      // カメラでお客様番号/認証番号が入力されている場合の処理
      let selects = await this.APP_CU5203();

      // 空の場合(紐づく表示地区情報がない)
      if (selects.length > 0) {
        const result = await this.$agreementSelectDialog(
          '$vuetify.agreementSelectDialog.確認',
          '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.C0004',
          '$vuetify.agreementSelectDialog.戻る',
          '$vuetify.agreementSelectDialog.登録',
          selects
        );
        if (result === true) {
          // 登録
          const result = await this.$agreementDialog(
            '$vuetify.agreementDialog.確認',
            '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.C0002',
            '$vuetify.agreementDialog.いいえボタン',
            '$vuetify.agreementDialog.はいボタン'
          );
          if (result === true) {
            await this.APP_CU5202();
          } else {
            // キャンセル
          }
        } else {
          // キャンセル
        }
      } else {
        // No.41のダイアログを表示する。
        this.callSaveMessageDialog(
          '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0023'
        );
      }
    },
    /**
     * APP_CU5203_表示地区情報取得
     * @returns {Array} 表示地区情報リスト
     */
    APP_CU5203: async function () {
      let param = '/api/mainUserTempRegistration/getDisplayDistrictInfo'; //本番用
      // let param = "post"; //検証用

      let queries = {
        customerNumber: this.customerNumber,
        authenticationNumber: this.certificationNumber,
      };

      let method = 'post';
      let apiData = '';
      let selects = [];
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: [
            //       {
            //         displayDistrictNickname: "displayDistrictNickname",
            //         customerNumber: "falcustomerNumberse",
            //         districtSplitNumber: "districtSplitNumber",
            //       },
            //       {
            //         displayDistrictNickname: "displayDistrictNickname2",
            //         customerNumber: "falcustomerNumberse2",
            //         districtSplitNumber: "districtSplitNumber2",
            //       },
            //       {
            //         displayDistrictNickname: "displayDistrictNickname3",
            //         customerNumber: "falcustomerNumberse3",
            //         districtSplitNumber: "districtSplitNumber3",
            //       },
            //     ],
            //   },
            // };

            apiData.contentsInfo.displayDistrictInfo.forEach((item) => {
              selects.push({
                id: item.districtSplitNumber, // 表示用
                text: item.displayDistrictNickname, // 表示用
                displayDistrictNickname: item.displayDistrictNickname, // 登録時に必要
                customerNumber: item.customerNumber, // 登録時に必要
                districtSplitNumber: item.districtSplitNumber, // 登録時に必要
              });
            });
          },
          (error /* eslint-disable-line */) => {
            this.$_abnormality(error.response.status);
          }
        );
      // console.log("APP_CU5203>>>", apiData);
      return selects;
    },
    /**
     * APP_CU5201_メインユーザー仮登録
     */
    APP_CU5201: async function () {
      // 正常系を確認したい場合は下記のコメントを解除する
      let param = '/api/mainUserTempRegistration/tempRegistration'; //本番用
      // let param = "post"; //検証用

      let queries = {
        customerNumber: this.customerNumber,
        authenticationNumber: this.certificationNumber,
        mail: this.mail,
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     serviceAddErrorCode: 1,
            //   },
            // };

            if (apiData.contentsInfo.serviceAddErrorCode == 0) {
              // Thanks画面に遷移する。
              this.$store.commit('setThanksType', {
                fromPageInfo: { page: 52 },
                displayType: 1,
              });
              this.$router.push('thanks');
            } else if (apiData.contentsInfo.serviceAddErrorCode == 1) {
              // No.36のダイアログを表示する。
              this.callSaveMessageDialog(
                '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0021'
              );
            } else if (apiData.contentsInfo.serviceAddErrorCode == 2) {
              // No.27のダイアログを表示する。
              this.callSaveMessageDialog(
                '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0024'
              );
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        );
    },
    /**
     * APP_CU5202_メインユーザー仮登録（カメラ）
     * @returns apiData APP_CU5202レスポンス
     */
    APP_CU5202: async function () {
      let param = '/api/mainUserTempRegistration/tempRegistrationCamera'; //本番用
      // let param = "post"; //検証用

      let districtSplitNumber = {};
      if (!!this.customerNumber && !!this.certificationNumber) {
        districtSplitNumber = this.$store.state.agreementSelectDialogSelectItem.districtSplitNumber;
      }
      let queries = {
        deviceID: this.deviceID,
        customerNumber: this.customerNumber,
        authenticationNumber: this.certificationNumber,
        districtSplitNumber: districtSplitNumber,
        mail: this.mail,
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     result: 1,
            //     webAuthenticationParameter: {
            //       clientId: "clientIdaaaa",
            //       state: "stateaaa",
            //       oneTimeUrlId: "oneTimeUrlIdaaa",
            //     },
            //     checkOneTimeUrlId: "checkOneTimeUrlId",
            //   },
            // };
            if (apiData.contentsInfo.result == 1) {
              // TODO アプリからブラウザに渡せるのか？
              localStorage.setItem(
                'client_id',
                apiData.contentsInfo.webAuthenticationParameter.clientId
              );
              localStorage.setItem('state', apiData.contentsInfo.webAuthenticationParameter.state);
              localStorage.setItem(
                'oneTimeUrlId',
                apiData.contentsInfo.webAuthenticationParameter.oneTimeUrlId
              );

              this.openHomeLink(apiData.contentsInfo);
            } else if (apiData.contentsInfo.result == 2) {
              // No.27のダイアログを表示する。
              this.callSaveMessageDialog(
                '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0024'
              );
            } else if (apiData.contentsInfo.result == 3) {
              // No.41のダイアログを表示する。
              this.callSaveMessageDialog(
                '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0021'
              );
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        );
      // console.log("APP_CU5202>>>", apiData);
      return apiData;
    },
    /**
     * ダミー画面（cameraAuth）を別タブで開く
     * @param {object} contentsInfo APP_CU5202レスポンス
     */
    async openHomeLink(params) {
      // No.38のダイアログを表示する。
      const result = await this.$informationDialog(
        '$vuetify.メッセージ一覧.FECU46サービス追加画面.C0005'
      );
      if (result === true) {
        if (this.$isMobileApp) {
          // ブラウザアプリでcameraAuthを開く
          const userAgent = navigator.userAgent;
          let os = '';
          if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            os = 'ios';
          }
          if (/android/i.test(userAgent)) {
            os = 'android';
          }
          NativeApi.openBrowserApp(
            location.origin + '/' + (os == 'ios' ? encodeURIComponent('#') : '#') + '/cameraAuth'
          );
        } else {
          // cameraAuthを別タブで開く
          window.open('/#/cameraAuth', '_blank');
        }
        // 繰り返し実行
        await this.APP_CO9902(params);
      }
    },
    /**
     * APP_CO9902_カメラ連携完了チェック
     * @param {object} contentsInfo APP_CU4603レスポンス
     */
    APP_CO9902: async function (params) {
      this.$_setLoading(true);

      let apiData = '';
      let queries = {
        oneTimeUrlId: params.checkOneTimeUrlId,
      };
      await this.$store
        .dispatch(`requestApi/postCameraCoordinationCheck`, {
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = response;
            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     oneTimeUrlStatus: 1,
            //     cameraCoordinationResult: 2,
            //   },
            // };
            if (apiData.contentsInfo.cameraCoordinationResult == 0) {
              // Thanks画面に遷移する。
              this.$store.commit('setThanksType', {
                fromPageInfo: { page: 52 },
                displayType: 1,
              });
              this.$router.push('thanks');
            } else if (apiData.contentsInfo.cameraCoordinationResult == 1) {
              // No.34のダイアログを表示する。
              this.callSaveMessageDialog(
                '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0016'
              );
            } else if (apiData.contentsInfo.cameraCoordinationResult == 2) {
              // 3分以上経過した場合
              // エラーダイアログ（No.34のダイアログ）を表示し、APP_CO9902の繰り返し実行を止める。
              this.callSaveMessageDialog(
                '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0016'
              );
              // 3分未満
              // APP_CO9902 APIを再度実行。 requestApi/postCameraCoordinationCheck で実行
            } else if (apiData.contentsInfo.cameraCoordinationResult == 3) {
              // No.40のダイアログを表示する。
              this.callSaveMessageDialog(
                '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0022'
              );
            }
          },
          (error) => {
            // 異常系処理
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     *  仮登録ボタン非活性制御
     */
    submitDisabled: function () {
      if (!this.hasValidateErrors()) {
        if (this.service.id == 1) {
          if (
            this.customerNumber != '' &&
            this.certificationNumber != '' &&
            this.mail != '' &&
            this.mailCheck != ''
          ) {
            this.saveDisableFlag = false;
          } else {
            this.saveDisableFlag = true;
          }
        } else {
          if (
            this.deviceID != '' &&
            this.mail != '' &&
            this.mailCheck != '' &&
            ((this.customerNumber != '' && this.certificationNumber != '') ||
              (this.customerNumber == '' && this.certificationNumber == ''))
          ) {
            this.saveDisableFlag = false;
          } else {
            this.saveDisableFlag = true;
          }
        }
      } else {
        this.saveDisableFlag = true;
      }
    },
    /**
     * 入力チェックエラー状態の入力項目の有無判定処理
     * @returns {boolean} エラーがあるかどうか
     */
    hasValidateErrors: function () {
      if (this.service.id == 1) {
        return (
          this.hasErrorInRules(this.customerNumberRule1) ||
          this.hasErrorInRules(this.certificationNumberRule1) ||
          this.hasErrorInRules(this.mailRule) ||
          this.hasErrorInRules(this.mailCheckRule) ||
          this.matchingMailCheckRule !== true
        );
      } else {
        return (
          this.hasErrorInRules(this.deviceIDRule) ||
          this.hasErrorInRules(this.customerNumberRule2) ||
          this.hasErrorInRules(this.certificationNumberRule2) ||
          this.hasErrorInRules(this.mailRule) ||
          this.hasErrorInRules(this.mailCheckRule) ||
          this.matchingMailCheckRule !== true
        );
      }
    },
    /**
     * 入力チェックエラーの有無判定処理
     * @param {Array} rules
     * @returns {boolean} エラーがあるかどうか
     */
    hasErrorInRules: function (rules) {
      return rules.some((rule) => rule !== true);
    },
  },
  mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);
    //初期通信完了後に画面を表示
    this.isShowPage = true;
  },
};
